import { motion } from 'framer-motion';
import { 
  MessageSquare, 
  Zap, 
  CheckCircle, 
  Factory, 
  Sparkles, 
  ClipboardCheck,
  Truck 
} from 'lucide-react';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      icon: MessageSquare,
      title: 'Kontakt',
      description: 'FastLane oder Standard-Anfrage',
      timeline: 'Sofort',
    },
    {
      number: '02',
      icon: Zap,
      title: 'Sofortreaktion',
      description: 'Mitarbeiter meldet sich',
      timeline: 'FastLane: Minuten | Standard: Stunden',
    },
    {
      number: '03',
      icon: CheckCircle,
      title: 'Machbarkeitsprüfung',
      description: 'Direkte Besprechung Ihres Anliegens',
      timeline: 'Am selben Tag',
    },
    {
      number: '04',
      icon: Factory,
      title: 'Produktion',
      description: 'Fertigung mit Foto-Dokumentation',
      timeline: 'Nach Vereinbarung',
    },
    {
      number: '05',
      icon: Sparkles,
      title: 'Veredelung',
      description: 'Optional durch ausgewählte Partner',
      timeline: 'Bei Bedarf',
    },
    {
      number: '06',
      icon: ClipboardCheck,
      title: 'Endkontrolle',
      description: 'Qualitätsprüfung & Dokumentation',
      timeline: 'Vor Versand',
    },
    {
      number: '07',
      icon: Truck,
      title: 'Lieferung',
      description: 'Ihr Wunschversand',
      timeline: 'Flexibel',
    },
  ];

  return (
    <section id="prozess" className="py-20 lg:py-32">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4">
            Von der Anfrage zur Lieferung
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Unser transparenter Prozess – Sie sind immer informiert
          </p>
        </motion.div>

        {/* Timeline */}
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Vertical Line */}
            <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-0.5 bg-border md:-translate-x-0.5" />

            {/* Steps */}
            {steps.map((step, index) => {
              const Icon = step.icon;
              const isEven = index % 2 === 0;

              return (
                <motion.div
                  key={step.number}
                  initial={{ opacity: 0, x: isEven ? -30 : 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className={`relative flex items-center mb-8 last:mb-0 ${
                    isEven ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  {/* Content */}
                  <div className={`flex-1 ml-16 md:ml-0 ${isEven ? 'md:pr-12 md:text-right' : 'md:pl-12'}`}>
                    <div className={`bg-card rounded-xl p-6 border border-border hover:shadow-lg transition-shadow ${
                      isEven ? 'md:mr-6' : 'md:ml-6'
                    }`}>
                      <div className={`flex items-center gap-3 mb-2 ${isEven ? 'md:justify-end' : ''}`}>
                        <span className="text-fastlane font-heading font-bold text-sm">
                          {step.number}
                        </span>
                        <h3 className="font-heading font-bold text-lg text-foreground">
                          {step.title}
                        </h3>
                      </div>
                      <p className="text-muted-foreground mb-2">{step.description}</p>
                      <p className="text-sm text-primary font-medium">{step.timeline}</p>
                    </div>
                  </div>

                  {/* Icon Circle */}
                  <div className="absolute left-0 md:left-1/2 md:-translate-x-1/2 w-12 h-12 rounded-full bg-gradient-hero flex items-center justify-center shadow-lg z-10">
                    <Icon className="w-5 h-5 text-white" />
                  </div>

                  {/* Spacer for alignment */}
                  <div className="hidden md:block flex-1" />
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
